import { fetchEndpoint } from "../network";

/**
 * 内容管理 - 晨视频报管理
 */

export default {
  // 列表
  fileImg(params, fromArticle) {
    if (!fromArticle) {
      fromArticle = false;
    }
    return fetchEndpoint("/upload/file", "POST", {
      fromArticle,
      url: params,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};

//获取cos签名,主要用来给富文本视频智能封面获取签名
export const getLinkSign = async (url, fromArticle) => {
  let res = await fetchEndpoint("/upload/file", "POST", {
    fromArticle: fromArticle ? true : false,
    url,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (res && res.code === 0) {
    return res.data.url;
  } else {
    return url;
  }
};

//获取视频带签名的智能封面
export const getVideoPoster = async (_url) => {
  let url = _url.split("?")[0];
  url = url.substring(0, url.lastIndexOf(".")) + "_0.jpg";
  console.log("要获取签名的封面", url);
  url = await getLinkSign(url, true);
  return url;
};

